import gql from 'graphql-tag'
import { gqlast } from '../graphqlParser'

/* Validación de tarjetas de crédito/débito con stripe */
const VALIDATE_INSTALLMENTS = (validationData) => {
    const newMutation = gqlast `mutation {
        validateInstallments(data:${validationData}) {
            intentId
            clientSecret
            availablePlans {
              count
              interval
              type
            }
        }
    }`
    return gql `${newMutation}`
}

/* Función para crear orden cuando el total de la orden es mayor a cero */
const CREATE_ORDER = (order) => {
    let newOrder = {
        paymentInformation: formatPaymentInformation(order),
        attendeeInformation: formatAttendeeInformation(order.attendeeInformation),
        billingInformation: order.billingInformation ? order.billingInformation : undefined,
        promotionCodeInformation: order.promotionCodeInformation,
        eventId: order.eventId,
        items: formatItems(order.items),
        sourceId: order.sourceId ? order.sourceId : "",
        payments: order.payments,
        organizationId: order.organizationId,
        total: parseFloat(order.total)
    }
    if (order.account.password) {
        order.buyer = {
            name: order.buyer.name,
            lastName: order.buyer.lastName,
            email: order.buyer.email,
            password: order.account.password
        }
    }
    const newMutation = gqlast `mutation {
        createOrder(data:${newOrder}) {
            id
        }
    }`
    return gql `${newMutation}`
}

/* Función para crear orden cuando el total de la orden es igual a cero */
const CREATE_FREE_ORDER = (order) => {
    let newOrder = {
        paymentInformation: formatPaymentInformation(order),
        attendeeInformation: formatAttendeeInformation(order.attendeeInformation),
        eventId: order.eventId,
        items: formatFreeItems(order.items),
        sourceId: order.sourceId ? order.sourceId : "",
        organizationId: order.organizationId,
        total: order.total,
        courtesy: order.courtesy ? order.courtesy : ""
    }
    const newMutation = gqlast `mutation {
        createFreeOrder(data:${newOrder}) {
            id
        }
    }`
    return gql `${newMutation}`
}

/* Función para hacer el checkIn del asistente con la cámara del celular */
const CHECK_IN = (checkInData) => {
    const newMutation = gqlast `mutation {
        checkInAttendee(data:${checkInData})
    }`
    return gql `${newMutation}`
}

/* Función para hacer checkIn del asitente mediante el tablero del organizador en la tabla de asistentes del evento */
const CHECK_IN_MANUAL = (checkInData) => {
    const newMutation = gqlast `mutation {
        checkInAttendeeManual(data:${checkInData})
    }`
    return gql `${newMutation}`
}

/* Función para enviar boletos a los asistetes mediante el tablero del organizador en la tabla de asistentes del evento */
const SEND_TICKET_ATTENDEE = (ticketData) => {
    const newMutation = gqlast `mutation {
        sendTicketAssistant(data:${ticketData})
    }`
    return gql `${newMutation}`
}

/* Función para eliminar boleto (COMPROBAR SI SE USA, SI NO SE USA ELIMINAR FUNCIÓN) */
const DELETE_TICKET = (id) => {
    const newMutation = gqlast `mutation {
        deleteProduct(id:${id})
    }`
    return gql `${newMutation}`
}

/* COMPROBAR SI SE USA, SI NO SE USA ELIMINAR FUNCIÓN */
const EXECUTE_CARD_PAYMENT = (cardInformation) => {
    const newMutation = gqlast `mutation {
        excuteCardPayment(data:${cardInformation})
    }`
    return gql `${newMutation}`
}

/* Función para formatear la información del pago */
const formatPaymentInformation = (order) => {
    return {
        name: order.buyer.name,
        lastName: order.buyer.lastName,
        email: order.buyer.email,
        paymentType: formatPaymentType(order.paymentInformation.paymentType)
    }
}

/* Función para formatear el método de pago para que sea aceptado por GraphQL */
const formatPaymentType = (paymentType) => {
    let newPaymentType = ""
    switch (paymentType) {
        case "Tarjeta de crédito o débito":
            newPaymentType = "CARD"
            break;
        case "SPEI":
            newPaymentType = "BANK_TRANSFER"
            break;
        case "Pago en OXXO":
            newPaymentType = "CASH"
            break;
        case "PayPal":
            newPaymentType = "PAYPAL"
            break;
        case "FREE":
            newPaymentType = "FREE"
            break;
        default:
            break;
    }
    return newPaymentType
}

/* Acomodar información de los asistentes para agregarla al objeto de "orden" */
const formatAttendeeInformation = (attendeeInformation) => {
    return attendeeInformation.map((attendee) => {
        return {
            companyName: attendee.companyName,
            email: attendee.email,
            lastName: attendee.lastName,
            name: attendee.name,
            tel: attendee.tel,
            ticketId: attendee.ticketId,
            ticketName: attendee.ticketName,
            accessType: attendee.accessType,
            ticketPrice: attendee.ticketPrice.toString(),
            passwordAccess: attendee.passwordAccess,
            extraFields: attendee
        }
    })
}

/* Acomodar información de los boletos adquiridos para agregarla al objeto de "orden" */
const formatItems = (items) => {
    let filteredItems = items.filter(item => item.quantity > 0);
    return filteredItems.map((item) => {
        return {
            productId: item.productId,
            productName: item.productName,
            productPrice: item.productPrice.toString(),
            quantity: item.quantity
        }
    })
}

/* Acomodar información de los boletos(GRATUITOS o con descuento del 100%) adquiridos para agregarla al objeto de "orden" */
const formatFreeItems = (items) => {
    let filteredItems = items.filter(item => item.quantity > 0);
    return filteredItems.map((item) => {
        return {
            productId: item.productId,
            productName: item.productName,
            productPrice: "0",
            quantity: item.quantity
        }
    })
}

/* Función para hacer editar la información del asistente */
const UPDATE_ATTENDEE = (attendee) => {
    const newMutation = gqlast `mutation {
        updateAttendee(data:${attendee})
    }`
    return gql `${newMutation}`
}
export { VALIDATE_INSTALLMENTS, CREATE_ORDER, CREATE_FREE_ORDER, CHECK_IN, CHECK_IN_MANUAL, SEND_TICKET_ATTENDEE, DELETE_TICKET, EXECUTE_CARD_PAYMENT, UPDATE_ATTENDEE }